import React, { useEffect, useState } from 'react'
import { BrowserRouter, Route, Switch, useHistory, withRouter, Redirect, Link, use } from 'react-router-dom'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Home from '../pages/Home';
import HomeTest from '../pages/HomeTest';
import Page404 from '../pages/Page404';
import Auth from '../pages/Auth';
import InternalDashboard from '../pages/internal/InternalDashboard';
import RegisteredUsers from '../pages/internal/RegisteredUsers';
import Users from '../pages/internal/Users';
import Help from '../pages/Help';
import Partners from '../pages/Partners';
import ResourceView from '../pages/ResourceView';
import Catalogues from '../pages/Catalogues';
import DomainView from '../pages/DomainView';
import Fsrcc from '../pages/Fsrcc';
import Roles from '../pages/internal/Roles';
import DatasetDomains from '../pages/internal/Datasets';
import UploadDataset from '../pages/internal/UploadDataset';
import Datasets from '../pages/internal/Datasets';
import Domains from '../pages/internal/Domains';
import Institutions from '../pages/internal/Institutions';
import Resource from '../pages/internal/Resource';
import ResourceGroup from '../pages/internal/ResourceGroup';
import View from '../pages/Views';
import { getPrivilegeStatus } from '../util';
import Resources from '../pages/Resources';
import DataView from '../pages/internal/DataView';
import CreateDataView from '../pages/internal/CreateDataView';
import CreateDataset from '../pages/internal/CreateDataset';
import PasswordReset from '../pages/PasswordReset';
import ListMdaAdmins from '../pages/internal/ListMdaAdmins';
import SystemParameters from '../pages/internal/SystemParameters';
import AuditLog from '../pages/internal/AuditLog';
import Publications from '../pages/Publications';
import FsrccNew from '../pages/FsrccNew';

const homepage = ''

const ScrollToTop = () => {
    const history = useHistory();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [history.location.pathname]);
  
    return null;
};

const ResetScroll = withRouter(ScrollToTop);



const Routes = ({ user }) => {
    const [ authenticated, setAuthenticated ] =  useState(user?.authenticated || false);
    
    const init = async () => {
        try {

        }
        catch(err) {
            console.log(err)
        }
    }

    useEffect(() => {
        init();
    }, [])

    useEffect(() => {
        setAuthenticated(user.authenticated && !user.userData.pwd_reset)
    }, [user])

    const PrivateRoute = ({ component: Component, exact, id, ...rest }) => {
        return (
            <Route
                {...rest}
                render={(props) =>
                    (authenticated && (getPrivilegeStatus(id) || !id)) ? <Component {...props} /> : <Redirect to={`${homepage}/internal`} />
                }
                exact={exact}
            />
        );
    };

    return (
        <BrowserRouter>
            <ResetScroll />
            <Switch>
                <Route exact path={`${homepage}/home`}>
                    <Redirect to={`${homepage}/`} />
                </Route>

                <Route exact path={`${homepage}/`} component={Home} />
                <Route exact path={`${homepage}/login`} component={Auth} />
                <Route exact path={`${homepage}/password-reset`} component={PasswordReset} />
                <Route exact path={`${homepage}/home-test`} component={HomeTest} />
                <Route exact path={`${homepage}/partners`} component={Partners} />
                <Route exact path={`${homepage}/catalogues`} component={Catalogues} />
                {/* <Route exact path={`${homepage}/view/:name`} component={DataView} /> */}
                {/* <Route exact path={`${homepage}/resource-view/:dataset`} component={ResourceView} /> */}
                <Route exact path={`${homepage}/data-domain/:domain/:category`} component={DomainView} />
                <Route exact path={`${homepage}/data-domain/:domain`} component={DomainView} />
                <Route exact path={`${homepage}/view/:resourceID`} component={View} id="" />

                <Route exact path={`${homepage}/resources`} component={Resources} />
                <Route exact path={`${homepage}/help`} component={Help} />
                <Route exact path={`${homepage}/fsrcc`} component={FsrccNew} />
                <Route exact path={`${homepage}/internal`} component={Auth} />
                <Route exact path={`${homepage}/publications`} component={Publications} />

                <PrivateRoute exact path={`${homepage}/internal/users`} component={Users} id="viewUsers" />
                <PrivateRoute exact path={`${homepage}/internal/roles`} component={Roles} id="viewRoles" />
                <PrivateRoute exact path={`${homepage}/internal/upload`} component={UploadDataset} id="viewUpload" />
                <PrivateRoute exact path={`${homepage}/internal/datasets`} component={Datasets} id="viewDatasets" />
                <PrivateRoute exact path={`${homepage}/internal/list-mda-admins`} component={ListMdaAdmins} id="viewAdminContacts" />

                <PrivateRoute exact path={`${homepage}/internal/datasets/create`} component={CreateDataset} id="viewDatasets" />
                
                <PrivateRoute exact path={`${homepage}/internal/data-views`} component={DataView} id="viewDatasets" />
                <PrivateRoute exact path={`${homepage}/internal/data-views/create`} component={CreateDataView} id="viewDatasets" />

                <PrivateRoute exact path={`${homepage}/internal/institutions`} component={Institutions} id="viewInstitutions" />
                <PrivateRoute exact path={`${homepage}/internal/domains`} component={Domains} id="viewDomains" />
                <PrivateRoute exact path={`${homepage}/internal/resource`} component={Resource} id="viewResources" />
                <PrivateRoute exact path={`${homepage}/internal/resourcegroup`} component={ResourceGroup} id="viewResourceGroup" />
                <PrivateRoute exact path={`${homepage}/internal/system-parameters`} component={SystemParameters} id="viewResourceGroup" />
                <PrivateRoute exact path={`${homepage}/internal/audit-logs`} component={AuditLog} id="viewResourceGroup" />

                <Route path="**">
                    <Page404 />
                </Route>
            </Switch>
        </BrowserRouter>
    )
}

const mapStateToProps = ({ user }) => ({ user })

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Routes);
